// File: src/components/shared/TextSection.jsx
import React from 'react'
import Text from '../textStyleDefault/texto'

interface TextSectionProps {
  title: string
  children: React.ReactNode
}

const TextSection: React.FC<TextSectionProps> = ({ title, children }) => (
  <section className="mb-8">
    <Text as="h4" className=" mb-10">{title}</Text>
    <Text as='h5'>{children}</Text>
    <hr className="mt-6 border-gray-300" />
  </section>
)

export default TextSection
